import { STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'

export default function usePDPTagVisibility(): {
  isTagVisible: boolean
} {
  const { experimentBucket, init } = useStatsigExperiment(STATSIG_EXPERIMENTS.PDP_TAG_VISIBILITY)

  const isTagVisible =
    init && experimentBucket === STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.PDP_TAG_VISIBILITY].buckets?.groupA

  return { isTagVisible }
}
